module.exports = {"id":"232278","name":"Santiago Mosquera","rating":"72","photo":"./data/images/photos/4/232278.png","club":{"name":"FC Dallas","logo":"./data/images/clubs/FCDallas.png"},"positions":["MD","MG","AG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/SantiagoMosquera0.json
// module id = 3829
// module chunks = 0